import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { Link } from 'react-router';
import { BarChart } from 'react-d3-components';
import d3 from 'd3';
import round from 'lodash/round';
import {PanelWrapper} from 'components/UI'
import NotificationToast from 'components/UI/NotificationToast';
import ActivityLog from 'components/Form/Fields/ActivityLog';
import CalendarDailyView from 'components/UI/CalendarDailyView';
import StatisticDisplay from './statisticDisplay';
import Loading from 'components/UI/Loading'
import { getSchoolLog } from '../Logs/ducks';
import { fetchSchoolStatistic } from './ducks';
import getTimetable from 'controllers/school/getTimetable'
import EmptyDataPlaceholder from 'components/UI/EmptyDataPlaceholder';
import __R, {userCan, isBasicUser } from 'containers/__R';
import moment from 'moment';
import locale from './locale'
import './style.scss';

const AMOUNT_PER_PAGE = 5;
const PAGE_RANGE_DISPLAYED = 5;
const CHART_MARGIN = {top: 30, bottom: 50, left: 30, right: 30};
const mapStateToProps = state => ({
  schoolLog: state.schoolLog,
  schedule: state.schedule,
  schoolStatistic: state.schoolStatistic,
});
const CHECKIN_COLORS = ['#16388b', '#FEB64D'];
const REGI_COLORS = ['#16388b', '#FB617F', '#FEB64D'];
const colorScaleCheckin = d3.scale.ordinal().range(CHECKIN_COLORS);
const colorScaleRegi = d3.scale.ordinal().range(REGI_COLORS);
const mapDispatchToProps = dispatch => {
  return {
    getSchoolLog: (schoolId, params) => dispatch(getSchoolLog(schoolId, params)),
    fetchSchoolStatistic: (schoolId)=>dispatch(fetchSchoolStatistic(schoolId))
  };
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lessonInfo: {},
      activePage: 1,
      checkinStatistic: [],
      regiStatistic: [],
      showCheckInDateRange: 7,
      showRegiDateRange: 7,
      statisticFromServer: {},
      hasValidCheckinStatistic: false,
      hasValidRegiStatistic: false,
      chartSize :{
        width: null,
        height: 300
      }
    }
    this.showNotification = this.showNotification.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onDateFilterChange = this.onDateFilterChange.bind(this);
    this.showCheckinTooltip = this.showCheckinTooltip.bind(this);
    this.showRegiTooltip = this.showRegiTooltip.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if(!nextProps.schoolStatistic.statistic){
      return null
    }
    if(nextProps.schoolStatistic.statistic !== this.props.schoolStatistic.statistic){
      this.setState({
        statisticFromServer: nextProps.schoolStatistic.statistic
      },()=>{
        this.formatCheckinStatistic();
        this.formatRegiStatistic();
      })
    }
  }
  componentWillMount(){
    window.addEventListener('resize', ()=>{
      this.resizeChart();
    });
    if(userCan('timetable_channel')){
      this.fetchSchedule()
    }
    if(userCan('operation_log_channel')){
      this.fetchLogs();
    }
    this.fetchStatistic();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', ()=>this.resizeChart());
  }
  resizeChart() {
    const width = this.chartWrapperNode.clientWidth-CHART_MARGIN.left-CHART_MARGIN.right;
    const { chartSize } = this.state;
    if (width !== chartSize.width) {
      this.setState({
        chartSize: { ...this.state.chartSize, width },
      });
    }
  }
  formatCheckinStatistic(){
    let checkInData = [{
      label: 'Attend',
      values: []
    },{
      label: 'Absent',
      values: []
    }];
    const { showCheckInDateRange } = this.state;
    let checkInStatisObject = this.state.statisticFromServer.check_in_data_30days_ago;
    let keys = Object.keys(checkInStatisObject);
    let hasValidCheckinStatistic = false;
    for(let i=0; i<showCheckInDateRange; i++){
      let date = moment(keys[i]).format('MM/DD');
      let item = checkInStatisObject[keys[i]];
      let absentPercentage = (item.absent_amount+item.counted_amount)>0? item.absent_amount/(item.absent_amount+item.counted_amount) : 0;
      let attendPercentage = (item.absent_amount+item.counted_amount)>0? item.counted_amount/(item.absent_amount+item.counted_amount) : 0;
      if(absentPercentage>0 || attendPercentage>0){
        hasValidCheckinStatistic = true;
      }
      let absentItem = {
        x: date,
        y: absentPercentage*100
      }
      let attendItem = {
        x: date,
        y: attendPercentage*100
      }
      checkInData[0].values.unshift(attendItem);
      checkInData[1].values.unshift(absentItem);
    }
    this.setState({
      checkinStatistic: checkInData,
      hasValidCheckinStatistic,
    })
  }
  formatRegiStatistic(){
    let regiData = [{
      label: 'FromReception',
      values: []
    },{
      label: 'FromPoster',
      values: []
    },{
      label: 'FromContact',
      values: []
    }];
    const { showRegiDateRange } = this.state;
    let regiStatisObject = this.state.statisticFromServer.student_registration_data_30days_ago;
    let keys = Object.keys(regiStatisObject);
    let hasValidRegiStatistic = false;
    for(let i=0; i<showRegiDateRange; i++){
      let date = moment(keys[i]).format('MM/DD');
      let item = regiStatisObject[keys[i]];
      if(item.converted_from_contact> 0 || item.registered_at_reception>0 || item.registered_from_poster>0){
        hasValidRegiStatistic = true;
      }
      let fromContactItem = {
        x: date,
        y: item.converted_from_contact
      }
      let fromReceptionItem = {
        x: date,
        y: item.registered_at_reception
      }
      let fromPosterItem = {
        x: date,
        y: item.registered_from_poster
      }
      regiData[0].values.unshift(fromReceptionItem);
      regiData[1].values.unshift(fromPosterItem);
      regiData[2].values.unshift(fromContactItem);
    }
    this.setState({
      regiStatistic: regiData,
      hasValidRegiStatistic,
    })
  }
  fetchStatistic() {
    const schoolId = localStorage.getItem('schoolId');
    this.props.fetchSchoolStatistic(schoolId);
  }
  fetchSchedule(){
    const { activePage } = this.state;
    const currentDate = moment().format('YYYY-MM-DD');
    const schoolId = localStorage.getItem('schoolId');
    const params = {
      start_date: currentDate,
      end_date: currentDate,
      page_or_not: 1,
      amount_per_page: AMOUNT_PER_PAGE,
      page_number: activePage
    }
    getTimetable(schoolId, params)
      .then(res=>{
        res.data.result_list.map(item=>{
          item.title = `${item.class_name} (${__('Lesson', locale)} ${item.lIndex})`;
        })
        this.setState({ 
          lessonInfo: res.data
        });
      })
  }
  fetchLogs() {
    const schoolId = localStorage.getItem('schoolId');
    const { activePage } = this.state;
    const params = {
      current_page_number: activePage,
      amount_per_page: AMOUNT_PER_PAGE,
    }
    this.props.getSchoolLog(schoolId, params);
  }
  onPageChange(pageNumber){
    this.setState({activePage: pageNumber},()=>{
      this.fetchSchedule();
    });
  }
  showNotification(){
    this.toast.showToast(`this is a test`,{
      onClose: ()=>console.log('closed'),
    });
  }
  onDateFilterChange(type, e){
    let key = type === 'checkin'? 'showCheckInDateRange': 'showRegiDateRange';
    this.setState({
      [key] : e.target.value
    },()=>{
      if(type === 'checkin'){
        this.formatCheckinStatistic();
      }else{
        this.formatRegiStatistic();
      }
    })
  }
  renderSelect(type){
    const { showCheckInDateRange, showRegiDateRange } = this.state;
    const currentDateRange = type === 'checkin'? showCheckInDateRange: showRegiDateRange
    return(
      <select className='select' onChange={(e)=>this.onDateFilterChange(type, e)} value={currentDateRange}>
        <option value="7">{__('Past {numberOfDays} days', locale, {numberOfDays: 7})}</option>
        <option value="30">{__('Past {numberOfDays} days', locale, {numberOfDays: 30})}</option>
      </select>
    );
  }
  setTickValues(type){
    const { regiStatistic, checkinStatistic } = this.state;
    let tickValues = [];
    let currentTicks = type === 'checkin'? checkinStatistic[0].values: regiStatistic[0].values;
    let length = currentTicks.length;
    if(length >= 30){
      for(let i=0; i<length; i++){
        if(i===0 || i%3 === 0){
          tickValues.push(currentTicks[i].x)
        }else {
          tickValues.push('')
        }
      }
    }else{
      let i=0;
      while(i<length){
        tickValues.push(currentTicks[i].x)
        i++;
      }
    }
    return tickValues;
  }
  showCheckinTooltip(x,y,y0){
    let checkinStatisticFromServer = this.state.statisticFromServer.check_in_data_30days_ago;
    let hoveredData = {};
    for (let key in checkinStatisticFromServer){
      if(x === moment(key).format('MM/DD')){
        hoveredData = checkinStatisticFromServer[key];
        break;
      }
    }
    return(
      <div>
        <div className='tooltipDate'>{__('Date', locale)}: {x}</div>
        <div>{__('Attending Rate', locale)}: {round(((hoveredData.counted_amount/(hoveredData.counted_amount + hoveredData.absent_amount))*100), 2)}%</div>
        <div>{__('Absent Rate', locale)}: {round(((hoveredData.absent_amount/(hoveredData.counted_amount + hoveredData.absent_amount))*100), 2)}%</div>
      </div>
    );
  }
  showRegiTooltip(x,y,y0){
    let regiStatisticFromServer = this.state.statisticFromServer.student_registration_data_30days_ago;
    let hoveredData = {};
    for (let key in regiStatisticFromServer){
      if(x === moment(key).format('MM/DD')){
        hoveredData = regiStatisticFromServer[key];
        break;
      }
    }
    return(
      <div>
        <div className='tooltipDate'>{__('Date', locale)}: {x}</div>
        <div>{__('From Reception', locale)}: {hoveredData.registered_at_reception}</div>
        <div>{__('From Poster', locale)}: {hoveredData.registered_from_poster}</div>
        <div>{__('From Contact', locale)}: {hoveredData.converted_from_contact}</div>
      </div>
    );
  }
  renderChart(type){
    const { checkinStatistic, regiStatistic, hasValidCheckinStatistic, hasValidRegiStatistic, chartSize } = this.state;
    if(type === 'checkin'){
      return(
        <div className='chart-wrapper block-wrapper' ref={(ref) => this.chartWrapperNode = ref}>
          <div className='description-wrapper'>
            <div className='graph-title'>{__('Attending and Absent Rate for All Classes', locale)}</div>
            {
              hasValidCheckinStatistic &&
              <div className='graph-labels'>
                <div className='graph-label'><div className='circle' style={{backgroundColor: CHECKIN_COLORS[0]}}></div>{__('Attending Rate', locale)}</div>
                <div className='graph-label'><div className='circle' style={{backgroundColor: CHECKIN_COLORS[1]}}></div>{__('Absent Rate', locale)}</div>
              </div>
            }
          </div>
          { hasValidCheckinStatistic &&
            <BarChart 
              data={checkinStatistic}
              width={chartSize.width || this.chartWrapperNode.clientWidth-CHART_MARGIN.left-CHART_MARGIN.right}
              height={chartSize.height}
              margin={CHART_MARGIN}
              colorByLabel={true} 
              barPadding={0.2}
              colorScale={colorScaleCheckin}
              tooltipHtml={this.showCheckinTooltip}
              tooltipOffset={{top: 10, left: 10}}
              xAxis={{tickValues: this.setTickValues('checkin')}}
              yAxis={{tickArguments: [5]}}    
            />
          }
          {
            !hasValidCheckinStatistic &&
            <EmptyDataPlaceholder title={__('No Checkin Data', locale)} icon='icon-clipboard-check' />
          }
          {this.renderSelect(type)}
        </div>
      );
    }else if(type === 'regi'){
      return(
        <div className='chart-wrapper block-wrapper'>
          <div className='description-wrapper'>
            <div className='graph-title'>{__('New Student Registration Data', locale)}</div>
            {
              hasValidRegiStatistic &&
              <div className='graph-labels'>
                <div className='graph-label'><div className='circle' style={{backgroundColor: REGI_COLORS[0]}}></div>{__('From Reception', locale)}</div>
                <div className='graph-label'><div className='circle' style={{backgroundColor: REGI_COLORS[1]}}></div>{__('From Poster', locale)}</div>
                <div className='graph-label'><div className='circle' style={{backgroundColor: REGI_COLORS[2]}}></div>{__('From Contact', locale)}</div>
              </div>
            }
          </div>
          { hasValidRegiStatistic &&
            <BarChart 
              data={regiStatistic}
              width={chartSize.width || this.chartWrapperNode.clientWidth-CHART_MARGIN.left-CHART_MARGIN.right}
              height={chartSize.height}
              margin={CHART_MARGIN}
              barPadding={0.2}
              colorByLabel={true} 
              colorScale={colorScaleRegi}
              tooltipHtml={this.showRegiTooltip}
              tooltipOffset={{top: 10, left: 10}}
              xAxis={{ tickValues: this.setTickValues('regi') }}
              yAxis={{tickArguments: [5], tickFormat: d3.format('d')}}    
            />
          }
          { !hasValidRegiStatistic &&
            <EmptyDataPlaceholder title={__('No New Registration', locale)} icon='icon-perm_contact_calendar' />
          }
          {this.renderSelect(type)}
        </div>
      );
    }else{
      return null;
    }
  }
  renderLogs(){
    const { schoolLog } = this.props;
    const { result_list } = schoolLog.logs;
    if(userCan('operation_log_channel')){
      if(!schoolLog.fetching && result_list){
        return (
          <div>
            <div className='header'>
              <span>{__("Recent Activity Log", locale)}</span>
              <Link to={'/logs/'}>{__("More", locale)}</Link>
            </div>
            {
              Object.keys(result_list).length>0 &&
              <ActivityLog resultList={result_list} />
            }
            {
              Object.keys(result_list).length === 0 && 
              <EmptyDataPlaceholder title={__('No Activity Log', locale)} icon='icon-assignment' />
            }
          </div>
        );
      }else {
        return null;
      }
    }else {
      return (
        <div>
          <div className='header'>
            <span>{__("Recent Activity Log", locale)}</span>
          </div>
          <EmptyDataPlaceholder title={__('No Permission', locale)} icon='icon-assignment' />
        </div>
      )
    }
  }
  render(){
    const { lessonInfo } = this.state;
    const { schoolStatistic, schoolLog } = this.props;
    const pagination = {
      activePage: this.state.activePage,
      itemsCountPerPage: AMOUNT_PER_PAGE,
      totalItemsCount: lessonInfo.total_amount,
      pageRangeDisplayed: PAGE_RANGE_DISPLAYED,
    }
    return (
      <PanelWrapper title={__('Dashboard', locale)}>
        <div className='main-container'>
          <div className='left-container'>
            {
              !schoolStatistic.fetching &&
              <div>
                <StatisticDisplay data={schoolStatistic.statistic}/>
                {this.renderChart('checkin')}
                {this.renderChart('regi')}
              </div>
            }
            {
              schoolStatistic.fetching &&
              <Loading />
            }
          </div>
          <div className='right-container'>
            <div className='schedule-wrapper block-wrapper' style={{position: (lessonInfo && lessonInfo.total_amount > 0)?'static': 'relative'}}>
              <div className='header'>{__("Today's Lessons", locale)}</div>
              {
                userCan('timetable_channel') && 
                <CalendarDailyView 
                  data={lessonInfo}
                  pagination={pagination}
                  onPageChange={this.onPageChange}
                  placeholderTitle={__('No Lesson Data', locale)}
                />
              }{
                !userCan('timetable_channel') &&
                <EmptyDataPlaceholder title={__('No Permission', locale)} icon='icon-chalkboard' />
              }
            </div>
            {
              !isBasicUser() && 
              <div className='log-wrapper block-wrapper'>
                {this.renderLogs()}
              </div>
            }
          </div>
        </div>
      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/pages/Dashboard/index.js